import React from 'react'

export default function Logo({ size = 44, mono = false, showWordmark = true }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 14 }}>
      <img src="/assets/smt-logo-full.png" alt="SMT Construction"
        style={{ height: size, width: 'auto', display: 'block',
          filter: mono ? 'grayscale(1) brightness(0.4)' : 'none' }} />
      {showWordmark && (
        <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.05, borderLeft: '1px solid var(--line)', paddingLeft: 14 }}>
          <span style={{ fontFamily: "'Engraver', 'Engravers MT', serif", fontWeight: 700, fontSize: 17, letterSpacing: '0.08em', color: 'rgb(0,117,29)', textTransform: 'uppercase' }}>SMT Construction.PVT LTD</span>
          <span style={{ fontFamily: 'var(--text)', fontSize: 11, fontWeight: 500, color: 'var(--fg-2)', marginTop: 5, letterSpacing: '0.04em' }}>EST. 1989 · KATHMANDU</span>
        </span>
      )}
    </span>
  )
}
